/* The bot trap (snippets/dm-bot-trap.liquid, v4.27.0). Tells the DM Portal's recorder (the script's data-recorder,
   through the app proxy, which passes it the visitor's IP and browser):
   - 'link': this is the trap page, /sf_dm-check, which only the hidden link on every page leads to and which every
     crawler that obeys robots.txt stays out of;
   - 'form': the hidden form was sent by a script; it then stays on the page (a bot without JavaScript posts the
     form to the recorder itself);
   - 'signup-field': the blog sign-up came with its hidden field filled (assets/blog.js calls dmBotTrap.report).
   It sends the kind and the page's path only, never what was typed; each kind once a page; and nothing from a page
   the browser prerendered and never showed. With no data-recorder it sends nothing. README → Bot trap. */
(function () {
  'use strict';
  var TRAP_PATH = '/sf_dm-check';
  var script = document.currentScript;
  var recorder = script && script.getAttribute('data-recorder');
  var sent = {};

  function send(kind) {
    if (!recorder || sent[kind]) return;
    sent[kind] = true;
    var body = JSON.stringify({ kind: kind, path: window.location.pathname });
    // one request: a beacon the browser refuses (a blocker's answer) is not sent again by fetch
    try {
      if (navigator.sendBeacon) { navigator.sendBeacon(recorder, body); return; }
    } catch (e) { /* fall through to fetch */ }
    try {
      window.fetch(recorder, { method: 'POST', body: body, keepalive: true, credentials: 'omit' }).catch(function () {});
    } catch (e) { /* nothing more to try */ }
  }

  function report(kind) {
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', function () { send(kind); }, { once: true });
    } else {
      send(kind);
    }
  }

  window.dmBotTrap = { report: report };

  if (window.location.pathname === TRAP_PATH) report('link');

  var form = document.querySelector('.dm-bt form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      report('form');
    });
  }
})();
